import { Component, OnInit,
Input,
Output,
EventEmitter
} from '@angular/core';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-eis-btn',
  templateUrl: './eis-btn.component.html',
  styleUrls: ['./eis-btn.component.css']
})
export class EisBtnComponent implements OnInit {
  @Input() name:string;
  @Input() btnName:string;
  @Input() title:string;
  @Input() width: number;
  @Input() height: number;
  @Input() cssClass: string;
  @Input() styleClass: string;
  @Output() clickEvt = new EventEmitter();
  @Input() btnDisabled = false;
  @Input() marginTop:string = "2";
  @Input() marginLeft:string = "4";
  @Input() bHeight:string = "22"
  @Input() marginRight:string = "0";
  
  customId = String(Math.random() * (13904.4953 - 1039.39402) + 4.9);
  processing = false;

  constructor() {
  }

  ngOnInit() {
  }

  getBtnDisabled() {
    return this.btnDisabled;
  }

  getDivClass() {
    return 'dv-btn-holder ' + this.cssClass;
  }

  getStyleClass() {
    if ( this.styleClass === undefined || this.styleClass === null) {
      return '';
    } else {
      return this.styleClass;
    }
  }

  keyboardDownEvent(event) {
    if ( this.processing === true ) return;
    if (event.which === 13 || event.which === 32) {
      this.btnClick();
    }
  }

  btnClick() {
    if ( this.processing === true ) return;
    this.processing = true;
    this.blur();
    delay(2000);
    this.clickEvt.emit();
  }

  blur() {
    document.getElementById(this.customId).blur();
  }

  enable() {

  }

  disable() {

  }

  setFocus() {
    document.getElementById(this.customId).focus();
  }

}
